import classNames from 'classnames'

// Alias classNames as cn to remove capitalization issues
export const cn = classNames
